import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { ListadoAsignaciones } from '@shared/enums/ListadoAsignaciones';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-asignacion-aeroplantas-index',
  templateUrl: './asignacion-aeroplantas-index.component.html'  
})
export class AsignacionAeroplantasIndexComponent {

  TipoUsuario = TipoUsuario;
  ListadoAsignaciones = ListadoAsignaciones;

  constructor(public authService:AuthService) {}
}
